export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1000px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-br from-background-800/60 via-background-800/30 to-background-800/60 border border-background-700/40 rounded-2xl p-8 md:p-12">
            <div className="flex-shrink-0">
              <div className="relative w-[180px] h-[180px] md:w-[220px] md:h-[220px] rounded-2xl overflow-hidden border-2 border-primary-500/30">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20minimalist%20smartphone%20mockup%20displaying%20a%20cinema%20streaming%20app%20interface%20with%20movie%20posters%20and%20a%20dark%20theme%2C%20warm%20golden%20accents%2C%20clean%20modern%20UI%20design%2C%20professional%20product%20photography%20on%20a%20dark%20cinematic%20background%20with%20soft%20spotlight%20effects&width=440&height=440&seq=app-mobile-qr&orientation=squarish"
                  alt="爱看影院移动端 — 随时随地免费观影"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
                移动端观影
              </h2>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6">
                爱看影院全面适配手机与平板，无论您在地铁、咖啡厅还是家中沙发，打开浏览器即可畅享高清免费电影与电视剧全集。无需下载安装，即点即播，流量优化让您放心追剧。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                {[
                  { icon: 'ri-smartphone-line', text: '手机平板全适配' },
                  { icon: 'ri-cloud-line', text: '无需下载即点即播' },
                  { icon: 'ri-signal-wifi-line', text: '智能省流优化' },
                ].map((item) => (
                  <span key={item.text} className="flex items-center gap-1.5 text-xs text-foreground-400">
                    <i className={`${item.icon} text-primary-400`}></i>
                    {item.text}
                  </span>
                ))}
              </div>

              <div className="mt-6">
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-950 font-semibold text-sm rounded-lg hover:bg-primary-400 transition-all cursor-pointer"
                >
                  <i className="ri-qr-scan-line text-base"></i>
                  手机扫码体验
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}